const cursorSmall = document.querySelector(".cursor-small");

function onMouseHover() {
  cursorSmall.style.height = "22px";
  cursorSmall.style.width = "22px";
}

function onMouseHoverOut() {
  cursorSmall.style.height = "44px";
  cursorSmall.style.width = "44px";
}

window.addEventListener("mousemove", (e) => {
  cursorSmall.style.left = `${e.clientX}px`;
  cursorSmall.style.top = `${e.clientY}px`;
  cursorSmall.style.opacity = "1";
});

function initCursorHoverables() {
  document
    .querySelectorAll("a, input, label, textarea, .hoverable")
    .forEach((el) => {
      el.addEventListener("mouseenter", onMouseHover);
      el.addEventListener("mouseleave", onMouseHoverOut);
    });
}

document.addEventListener("turbo:load", initCursorHoverables);
